import { FaHorse, FaFlagCheckered } from 'react-icons/fa';
import { FiActivity, FiClipboard, FiSettings, FiTag } from 'react-icons/fi';

export const navSections = [
  {
    key: 'horses',
    label: 'Horses',
    icon: FaHorse,
    maxRole: 14,
    links: [
      { to: '/horse-form', label: 'Horse Search' },
      { to: '/horse-compare', label: 'Compare' },
      { to: '/seasonal-records', label: 'Seasonal Records' },
      { to: '/blackbook', label: 'Blackbook' },
    ],
  },
  {
    key: 'breeding',
    label: 'Breeding',
    icon: FiActivity,
    maxRole: 14,
    links: [
      { to: '/horse-stats', label: 'Horse Stats' },
      { to: '/table/sire', label: 'Sire Table' },
      { to: '/sire-trends', label: 'Sire Trends' },
      { to: '/sire-crops', label: 'Crop Table' },
      { to: '/sire-upcoming', label: 'Upcoming Starters' },
      { to: '/pedigree', label: 'Pedigree' },
      { to: '/nicks', label: 'Nicks' },
      { to: '/data/stallions', label: 'Sire Reports' },
    ],
  },
  {
    key: 'racing',
    label: 'Racing',
    icon: FaFlagCheckered,
    maxRole: 14,
    links: [
      { to: '/racing', label: 'Jockey & Trainer Form' },
      { to: '/racing/race-history', label: 'Race History' },
      { to: '/racing/upcoming', label: 'Upcoming Runners' },
      { to: '/racing/ohr', label: 'OHR Predictor' },
    ],
  },
  {
    key: 'meetings',
    label: 'Meetings',
    icon: FiClipboard,
    maxRole: 14,
    // `/meetings/latest` redirects to `/meetings/:id` once the newest meeting
    // resolves, so the link has to claim the numeric routes too or it goes
    // dark on the very page it opened.
    links: [
      { to: '/meetings/latest', label: 'Races', matchPaths: ['/meetings'] },
      { to: '/trials/latest', label: 'Trials', matchPaths: ['/trials'] },
      { to: '/meetings/ratings', label: 'Ratings' },
      { to: '/meetings/nominations', label: 'Nominations' },
    ],
  },
  {
    key: 'sales',
    label: 'Sales',
    icon: FiTag,
    maxRole: 14,
    links: [
      { to: '/sales', label: 'Sales List' },
      { to: '/data/sales', label: 'Sales Reports' },
    ],
  },
  {
    key: 'settings',
    label: 'Settings',
    icon: FiSettings,
    maxRole: 5, // admin-only section
    links: [
      { to: '/blackbook-admin', label: 'Blackbook' },
    ],
  },
];
